import React from "react";
import theme from "../configuration/theme";
import {GlobalStyles, ScopedCssBaseline, ThemeProvider} from "@mui/material";
import { ContentProvider } from "../contexts/content";
import { StoreProvider } from "../contexts/store";

const ThemeProviderWrapper = ({ children }) => {
    return <StoreProvider><ContentProvider>
        <ThemeProvider theme={theme}>
            <ScopedCssBaseline >
            <GlobalStyles styles={{
                "*, ::after, ::before": {
                    boxSizing: 'border-box',
                    '-webkit-tap-highlight-color': 'transparent'
                },
                button:{
                    width: 'auto',
                    height: 'auto',
                    "&:hover":{
                        border: 0,
                        color: 'inherit',
                        backgroundColor: 'inherit'
                    }
                },
                legend:{
                  border: 0
                },
                input:{
                  height: 'inherit !important',
                  boxSizing: 'inherit !important',
                    fontFamily: '"Visuelt Pro", Helvetica, Arial, Roboto, sans-serif !important'
                },
                'div:empty':{
                    display: 'inherit'
                },
                '*:focus-visible': {
                    outline: 'none'
                }}}/>
            {children}
            </ScopedCssBaseline>
        </ThemeProvider>
    </ContentProvider></StoreProvider>
}

export default ThemeProviderWrapper;
